/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Email_OffInputs */

const en_fw_notify_email_off = /** @type {(inputs: Fw_Notify_Email_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is not configured on this server — NEEDS ADMIN ACTION: set RESEND_API_KEY and NOTIFY_FROM.`)
};

const id_fw_notify_email_off = /** @type {(inputs: Fw_Notify_Email_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email belum dikonfigurasi di server — BUTUH TINDAKAN ADMIN: isi RESEND_API_KEY dan NOTIFY_FROM.`)
};

/**
* | output |
* | --- |
* | "Email is not configured on this server — NEEDS ADMIN ACTION: set RESEND_API_KEY and NOTIFY_FROM." |
*
* @param {Fw_Notify_Email_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_email_off = /** @type {((inputs?: Fw_Notify_Email_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Email_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_email_off(inputs)
	return en_fw_notify_email_off(inputs)
});